import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { router } from './router.tsx';
import { useAuthStore } from './stores/auth-store.js';

export function App() {
  const restoreSession = useAuthStore((s) => s.restoreSession);
  const isLoading = useAuthStore((s) => s.isLoading);

  // Restore session on mount (validates token / refreshes if needed)
  useEffect(() => {
    restoreSession();
  }, [restoreSession]);

  // Wait for session restore before rendering routes.
  // This prevents the requireAuth loader racing against restoreSession.
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy-50 dark:bg-navy-950">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-navy-300 border-t-emerald-500" />
      </div>
    );
  }

  return <RouterProvider router={router} />;
}
